
/**
 * 플랫폼 지원
 */
export type CourseDraftUpdateSectionsItemLecturesItemPlatformSupport = typeof CourseDraftUpdateSectionsItemLecturesItemPlatformSupport[keyof typeof CourseDraftUpdateSectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftUpdateSectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
